import { type Ref, type Directive } from "vue";

const SHAKE_STYLE_ID = "__error-shake_style__";

const AnimationName = "error-shake-anim";
const CssClass = "error-shake";

function ensureShakeStyles() {
  if (document.getElementById(SHAKE_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = SHAKE_STYLE_ID;
  style.textContent =
    `
  @keyframes ` +
    AnimationName +
    ` {
    0% { transform: translateX(0); }
    15% { transform: translateX(-6px); }
    30% { transform: translateX(6px); }
    45% { transform: translateX(-4px); }
    60% { transform: translateX(4px); }
    75% { transform: translateX(-2px); }
    100% { transform: translateX(0); }
  }

  .` +
    CssClass +
    ` {
    animation: ` +
    AnimationName +
    ` 0.45s ease-in-out;
  }
  `;
  document.head.appendChild(style);
}

export interface ShakyElement extends HTMLElement {
  shake: () => void;
}

const errorShake: Directive<HTMLElement, Ref<boolean>> = {
  mounted(el) {
    ensureShakeStyles();
    (el as ShakyElement).shake = () => {
      el.classList.remove(CssClass);
      void el.offsetWidth;
      el.classList.add(CssClass);

      const onAnimEnd = (e: AnimationEvent) => {
        if (e.animationName === AnimationName) {
          el.classList.remove(CssClass);
          el.removeEventListener("animationend", onAnimEnd);
        }
      };

      el.addEventListener("animationend", onAnimEnd, { once: true });
    };
  },
};

export default errorShake;
